import { RouteConfig } from 'vue-router';
import { Permissions } from '@/types';
const Services = () =>
  import(/* webpackChunkName: "service-routes" */ '@/components/Services/Services.vue');
const Service = () =>
  import(/* webpackChunkName: "service-routes" */ '@/components/Services/Service.vue');

const routes: RouteConfig[] = [
  {
    path: 'services',
    name: 'services',
    components: {
      default: Services
    },
    meta: {
      pageTitle: 'Service'
    }
  },
  {
    path: 'services/:serviceId',
    name: 'service',
    component: Service,
    props: true,
    meta: {
      pageTitle: 'Service'
    }
  }
];

export default routes;
